import ModalDownloadApp from '@/components/Includes/Modals/ModalDownloadApp/ModalDownloadApp.vue';
import IProfile from '@/interfaces/IProfile';
import checkMobile from "@/libs/checkMobile";
import {Header as AppHeader, SidebarToggler} from '@coreui/vue';
import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import HeaderDropDown from './HeaderDropDown/HeaderDropDown.vue';


@Component({
    name: 'Header',
    components: {
        HeaderDropDown,
        AppHeader,
        SidebarToggler,
        ModalDownloadApp
    },
})
export default class Header extends Vue {
    @Action private changeDownloadAppStatus!: (downloadAppStatus: boolean) => void;
    @Getter private profile!: () => IProfile;

    private modalShow() {
        this.changeDownloadAppStatus(false);
    }
}
